var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0.329484663%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B816",
    offset: "99.934016%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beispiel",
    transform: "translate(-613.000000, -196.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638,196 C651.807119,196 663,207.192881 663,221 C663,234.807119 651.807119,246 638,246 C624.192881,246 613,234.807119 613,221 C613,207.192881 624.192881,196 638,196 Z M650.41367,210.003401 L625.760888,210.003401 L625.616481,210.009235 C624.711598,210.082654 624,210.839926 624,211.763089 L624,211.763089 L624,229.360207 L624.005838,229.504524 C624.079307,230.408835 624.837095,231.119896 625.760888,231.119896 L625.760888,231.119896 L650.41367,231.119896 L650.558085,231.114062 C651.463012,231.040643 652.174558,230.283371 652.174558,229.360207 L652.174558,229.360207 L652.174558,211.763089 L652.16872,211.618781 C652.095256,210.714514 651.337518,210.003401 650.41367,210.003401 L650.41367,210.003401 Z M648.652782,213.522836 L648.652782,225.84083 L641.609113,218.80196 L632.804557,227.600519 L627.521834,227.600519 L627.521834,213.522836 L648.652782,213.522836 Z M635.55274,216.055649 C634.521205,215.024817 632.848797,215.024817 631.817262,216.055649 C630.785727,217.086481 630.785727,218.75775 631.817262,219.788582 C632.848797,220.819414 634.521205,220.819414 635.55274,219.788582 C636.584274,218.75775 636.584274,217.086481 635.55274,216.055649 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialImage);
export default __webpack_public_path__ + "static/media/special_image.6f4057a8f5586b5fc2c178a609542f0c.svg";
export { ForwardRef as ReactComponent };